import { Text, InfoItem } from '@intellecteu/common-ui';
import { Labels, ResourcesType } from 'app/constants';
import { unitSplitter } from 'app/utils';
import { EnvVar } from 'data';
import { StepId } from '../../ui';

import s from './styles.module.scss';

type SummaryResourcesConfigValues = {
  resources?: ResourcesType;
  clusterConfig?: {
    appInfoCantonNameService?: {
      resources?: ResourcesType;
    };
    appInfoWallet?: {
      resources?: ResourcesType;
    };
    appInfoValidator?: {
      resources?: ResourcesType;
    };
  };
  participant?: {
    resources?: ResourcesType;
  };
};

type ResourcesSummaryFieldsType = { label: Labels; value: number | string | undefined; name: string };

export const generateResourceSummaryFields = (resources: ResourcesType): Array<ResourcesSummaryFieldsType> => {
  return [
    {
      label: Labels.REQUESTED_CPU,
      value: resources?.cpuRequested,
      name: 'resources.cpuRequested',
    },
    {
      label: Labels.CPU_LIMIT,
      value: resources?.cpuLimit,
      name: 'resources.cpuLimit',
    },
    {
      label: Labels.REQUESTED_MEMORY,
      value: unitSplitter(resources?.memoryRequested),
      name: 'resources.memoryRequested',
    },
    {
      label: Labels.MEMORY_LIMIT,
      value: unitSplitter(resources?.memoryLimit),
      name: 'resources.memoryLimit',
    },
    {
      label: Labels.REPLICAS,
      value: resources?.replicas,
      name: 'resources.replicas',
    },
  ];
};

export const getResourcesSummaryConfig = (values: SummaryResourcesConfigValues, isValidator = false) => {
  const { clusterConfig, participant, resources } = values;

  let resultResourcesMap: {
    resourcesSummaryFields: Array<ResourcesSummaryFieldsType>;
    resourcesCNSSummaryFields?: Array<ResourcesSummaryFieldsType>;
    resourcesInfoWalletSummaryFields?: Array<ResourcesSummaryFieldsType>;
    resourcesParticipantSummaryFields?: Array<ResourcesSummaryFieldsType>;
  } = {
    resourcesSummaryFields: [],
  };

  if (isValidator) {
    resultResourcesMap = Object.assign(resultResourcesMap, {
      resourcesCNSSummaryFields: [],
      resourcesInfoWalletSummaryFields: [],
      resourcesParticipantSummaryFields: [],
    });

    resultResourcesMap.resourcesSummaryFields = generateResourceSummaryFields(
      clusterConfig?.appInfoValidator?.resources as ResourcesType,
    );

    resultResourcesMap.resourcesCNSSummaryFields = generateResourceSummaryFields(
      clusterConfig?.appInfoCantonNameService?.resources as ResourcesType,
    );

    resultResourcesMap.resourcesInfoWalletSummaryFields = generateResourceSummaryFields(
      clusterConfig?.appInfoWallet?.resources as ResourcesType,
    );

    resultResourcesMap.resourcesParticipantSummaryFields = generateResourceSummaryFields(
      participant?.resources as ResourcesType,
    );
  } else {
    resultResourcesMap.resourcesSummaryFields = generateResourceSummaryFields(resources as ResourcesType);
  }

  return resultResourcesMap;
};

const envVarsSummaryValue = (envVarsArr?: EnvVar[], key?: string) => {
  return envVarsArr?.length
    ? envVarsArr.map((el, index) => {
        return (
          <div key={key || `variable-${index}`} className={s.summaryEnvVars}>
            <Text size="s" className={s.title}>{`Variable ${index + 1}`}</Text>
            <InfoItem label={Labels.NAME} value={el.name} />
            {el.value && <InfoItem label="Value" value={el.value} />}
            {el.valueFrom && (
              <>
                <InfoItem label={Labels.SECRET_KEY} value={el.valueFrom.secretKeyRef?.key} />
                <InfoItem label={Labels.SECRET_NAME} value={el.valueFrom.secretKeyRef?.name} />
                <InfoItem label={Labels.OPTIONAL} value={String(el.valueFrom.secretKeyRef?.optional)} />
              </>
            )}
          </div>
        );
      })
    : '–';
};

export const getEnvVarsSummaryConfig = (values: any) => {
  const { envVars } = values;

  const envVarsFields = {
    label: '',
    value: envVarsSummaryValue(envVars),
    name: 'envVars',
  };

  const envVarsSummary = {
    [StepId.ENV_VARS]: [
      {
        fields: [envVarsFields],
      },
    ],
  };

  return {
    envVarsSummary,
    envVarsSummaryValue,
    envVarsFields,
  };
};
